module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "phone1.5aa02a21.jpg";